import { render, staticRenderFns } from "./GerenciaImagen.vue?vue&type=template&id=177424be"
import script from "./GerenciaImagen.vue?vue&type=script&lang=js"
export * from "./GerenciaImagen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports